<template>
  <div class="index-container">
    <div class="index-bg" />
    <div class="center-container">
      <div class="login-head-button">
        LOG IN
      </div>
      <div class="login-description-box">
        <div class="login-text-group">
          <p class="login-text">
            เพื่อเข้าสู่หน้าเว็บไซต์สั่งซื้อบริการ
          </p>
          <p class="login-line-agentcy-text">
            LINE Agency by Sellsuki
          </p>
          <p class="login-partner-text">
            Partner อย่างเป็นทางการของ <strong>LINE</strong> ประเทศไทย
          </p>
          <img
            class="character"
            src="/img/index/character.svg"
          />
        </div>
        <hr />
      </div>
      <div class="package-container">
        <section class="package-section broadcast-package">
          <h2>Broadcast Package</h2>
          <div class="package-grid">
            <div class="package-card">
              <div class="card-header basic-header">
                <h3>แพ็กเกจ Basic</h3>
                <p>(15,000 ข้อความต่อเดือน)</p>
              </div>
              <div class="card-body">
                <div class="description-group bordered-box">
                  <p class="description">
                    เหมาะสำหรับร้านขนาดเล็ก
                  </p>
                  <p class="description">
                    บริหารลูกค้าได้อย่างคุ้มค่า
                  </p>
                </div>
                <div class="price-group bordered-box">
                  <p class="price-label">
                    เริ่มต้น
                  </p>
                  <p class="price">
                    3,840 <span class="currency">บาท/3 เดือน</span>
                  </p>
                  <p class="price-avg">
                    (เฉลี่ย 1,280 บาท/เดือน)
                  </p>
                </div>
              </div>
            </div>
            <div class="package-card">
              <div class="card-header pro-header">
                <h3>แพ็กเกจ Pro</h3>
                <p>(35,000 ข้อความต่อเดือน)</p>
              </div>
              <div class="card-body">
                <div class="description-group bordered-box">
                  <p class="description">
                    รองรับการสื่อสารแบบแมส
                  </p>
                  <p class="description">
                    เพิ่มโอกาสปิดการขายหลายเท่า
                  </p>
                </div>
                <div class="price-group bordered-box">
                  <p class="price-label">
                    เริ่มต้น
                  </p>
                  <p class="price">
                    5,340 <span class="currency">บาท/3 เดือน</span>
                  </p>
                  <p class="price-avg">
                    (เฉลี่ย 1,780 บาท/เดือน)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="package-section additional-services">
          <h2>Additional Services</h2>
          <div class="package-grid-additional">
            <div class="package-card service-card">
              <div class="card-header">
                <h3>ข้อความเพิ่มเติม</h3>
                <p>(Message Top-up)</p>
              </div>
              <div class="card-body">
                <div class="description-group bordered-box">
                  <p class="description">
                    เพิ่มข้อความบรอดแคสต์
                  </p>
                  <p class="description">
                    ได้ไม่จำกัด
                  </p>
                </div>
                <div class="service-pricing bordered-box">
                  <p>แพ็กเกจ Basic</p>
                  <p><span>ข้อความละ</span> <strong>0.10</strong> <span>บาท</span></p>
                  <div style="margin-top: 4%;" />
                  <p>แพ็กเกจ Pro</p>
                  <p><span>ข้อความละ</span> <strong>0.06</strong> <span>บาท</span></p>
                </div>
              </div>
            </div>
            <div class="package-card service-card">
              <div class="card-header">
                <h3>Premium ID</h3>
              </div>
              <div class="card-body">
                <div class="description-group bordered-box">
                  <p class="description">
                    เปลี่ยนเป็นชื่อ ID
                  </p>
                  <p class="description">
                    ที่จำง่าย เช่น
                  </p>
                  <p class="description">
                    @linebysellsuki
                  </p>
                </div>
                <div class="price-group bordered-box">
                  <p class="price-label">
                    ค่าบริการเพียง
                  </p>
                  <p class="price">
                    444 <span class="currency">บาท/ปี</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="package-card service-card">
              <div class="card-header">
                <h3>แพ็กเกจแชท</h3>
                <p>(OA Chat Package)</p>
              </div>
              <div class="card-body">
                <div class="description-group bordered-box">
                  <p class="description">
                    พื้นที่เก็บข้อความเยอะขึ้น<br />จัดการแชทได้มืออาชีพ
                  </p>
                </div>
                <div class="price-group bordered-box">
                  <p class="price-label">
                    เริ่มต้นแค่
                  </p>
                  <p class="price">
                    1,665 <span class="currency">บาท/3 เดือน</span>
                  </p>
                  <p class="price-avg">
                    (เฉลี่ย 555 บาท/เดือน)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <button
        class="gradient-button"
        @click="redirectToLiffLogin"
      >
        เข้าสู่ระบบ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexPage',
  methods: {
    async redirectToLiffLogin() {
      this.$liff.login({ redirectUri: this.$route.query.redirectUri })
    }
  }
}
</script>

<style scoped>
.index-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-family: "DB HeaventRounded";
  padding: 1em;
}

.index-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 0;
  background:
    url('/img/index/fg-desktop-br.png') bottom right no-repeat,
    url('/img/index/fg-desktop-tl.png') top left no-repeat,
    url('/img/index/fg-desktop-bl.png') bottom left no-repeat,
    url('/img/index/fg-desktop-tr.png') top right no-repeat,
    #EFEFEF;
}

.center-container {
  width: 1100px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.login-head-button {
  background: #00BD00;
  color: white;
  font-weight: bold;
  text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.5);
  padding: 0px 27px;
  border-radius: 100px;
  font-size: 2.5em;
}

.login-description-box {
  text-align: center;
  width: 100%;
  font-size: 3.8rem;
  line-height: 0.7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-text-group {
  position: relative;
}

.login-description-box .login-text {
  font-size: 3.5rem;
  font-weight: bold;
}

.login-description-box .login-line-agentcy-text {
  font-size: 5rem;
  color: #01bd00;
  font-weight: bold;
}

.login-description-box .login-partner-text {
  font-size: 2.9rem;
  font-weight: bold;
  color: #444444;
}

.login-description-box .login-partner-text strong {
  color: #01bd00;
  font-weight: bold;
}

.login-description-box .character {
  position: absolute;
  bottom: -6px;
  right: 100%;
  width: 120px;
}

.login-description-box hr {
  margin: 0 0 10px 0;
  width: 100%;
}

.gradient-button {
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
  background: linear-gradient(to right, #FF6B00, #FFA500);
  color: white;
  font-size: 2em;
  font-weight: bold;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  box-shadow:
      0 0 15px rgba(255, 255, 255, 0.7),
      0 3px 9px rgba(0, 0, 0, 0.8);
}

.gradient-button:hover {
  transform: translateY(-2px);
  box-shadow:
      0 0 20px rgba(255, 255, 255, 0.9),
      0 8px 25px rgba(0, 0, 0, 0.3);
}

.gradient-button:active {
  transform: translateY(0);
  box-shadow:
      0 0 10px rgba(255, 255, 255, 0.5),
      0 3px 10px rgba(0, 0, 0, 0.15);
}

.package-container {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    align-items: flex-start;

    width: 100%;
    height: 350px;
}

.package-section {
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
    overflow: hidden;
    flex-direction: column;
    display: flex;
    height: 100%;
}

.package-section h2 {
    font-size: 3em;
    font-weight: bold;
    color: #fff;
    padding: 5px 8px;
    margin: 0;
    text-align: center;
    background-color: #f37021;
    background-image: linear-gradient(to bottom, #fea318 0%, #ff3802 100%);
    border-radius: 6px 6px 0 0;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.package-grid, .package-grid-additional {
    flex: 1;
    display: grid;
    gap: 0;
    padding: 0;
}

.package-grid {
  grid-template-columns: 1fr 1fr;
}

.package-grid-additional {
  grid-template-columns: 1fr 1fr 1fr;
}

.package-card {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    text-align: center;
}

.card-header {
    height: 74px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px dotted #ccc;
    background-color: #00bd00;
    color: #ffffff;
    line-height: 1;
}

.package-grid .package-card:last-child .card-header,
.package-grid .package-card:last-child .bordered-box,
.package-grid-additional .package-card:last-child .card-header,
.package-grid-additional .package-card:last-child .bordered-box {
    border-right: none;
}

.card-body .bordered-box:nth-child(1) {
    border-top: none;
}

.card-header h3 {
    font-size: 1.7rem;
    font-weight: bold;
    margin: 0 0 5px 0;
}

.card-header p {
    font-size: 1rem;
    margin: 0;
    font-weight: bold;
}

.card-header h3 {
    background-color: #00bd00;
    color: #ffffff;
    margin: 0;
}

.card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    min-height: 180px;
    gap: 0;
}

.bordered-box {
  border-top: 1px dotted #ccc;
  border-right: 1px dotted #ccc;
  padding: 6px 10px;
}

.none-bordered-box {
  border-bottom: none;
}

.description-group, .price-group, .service-pricing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin: 0;
    padding: 5px 0;
    height: 50%;
}

.price-group, .service-pricing {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.card-body .description {
    font-size: 1.3rem;
    font-weight: bold;
    line-height: 1.1;
    margin: 0;
}

.card-body .price-label {
    font-size: 1.3rem;
    margin: 0;
    line-height: 1.1;
    font-weight: bold;
}

.card-body .price {
    font-size: 2rem;
    font-weight: bold;
    font-style: italic;
    color: #f37021;
    gap: 4px;
    line-height: 0.7;
    display: flex;
    align-items: last baseline;
    justify-content: center;
    margin: 0;
}

.card-body .price .currency {
    font-size: 1.3rem;
    font-weight: bold;
    vertical-align: middle;
    margin-left: 2px;
    color: #000000;
}

.card-body .price-avg {
    font-size: 1.3rem;
    color: #f37021;
    margin: 0;
    line-height: 1;
    font-style: italic;
    font-weight: normal;
}

.service-pricing {
    font-size: 14px;
    color: #333;
}
.service-pricing p {
    margin: 0;
    line-height: 0.7;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    font-weight: bold;
}
.service-pricing strong {
    color: #f37021;
    font-size: 1.6rem;
    font-weight: bold;
    font-style: italic;
    margin: 0 2px;
}

@media (max-width: 992px) {
  .index-container {
    padding: 2rem;
  }
  .index-bg {
    background:
      url('/img/index/fg-tablet-br.png') bottom right no-repeat,
      url('/img/index/fg-tablet-tl.png') top left no-repeat,
      url('/img/index/fg-tablet-bl.png') bottom left no-repeat,
      url('/img/index/fg-tablet-tr.png') top right no-repeat,
      #EFEFEF;
  }

  .login-description-box .login-text {
      font-size: 2.8rem;
      line-height: 0.5;
  }

  .login-description-box .login-line-agentcy-text {
      font-size: 3.2rem;
      line-height: 0.5;
  }

  .login-description-box .login-partner-text {
      font-size: 2.2rem;
      line-height: 0.5;
  }

  .login-description-box .character {
    width: 90px;
    bottom: -4px;
  }

  .package-section h2 {
    font-size: 2.4em;
  }

  .card-header h3 {
    font-size: 1.2rem;
  }

  .card-header p {
    font-size: 0.8rem;
  }

  .card-body .description {
    font-size: 0.9rem;
  }

  .card-body .price-label {
    font-size: 0.9rem;
  }

  .card-body .price {
    font-size: 1.4rem;
  }

  .card-body .price .currency {
    font-size: 0.9rem;
  }

  .card-body .price-avg {
    font-size: 0.9rem;
  }

  .service-pricing p {
    font-size: 0.9rem;
  }

  .service-pricing strong {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .index-bg {
    background:
      url('/img/index/fg-mobile-br.png') bottom right no-repeat,
      url('/img/index/fg-mobile-tl.png') top left no-repeat,
      url('/img/index/fg-mobile-bl.png') bottom left no-repeat,
      url('/img/index/fg-mobile-tr.png') top right no-repeat,
      #EFEFEF;
  }

  .login-head-button[data-v-23543608] {
      font-size: 1.8em;
  }

  .login-description-box .login-text {
      font-size: 1.2rem;
      line-height: 0.2;
  }

  .login-description-box .login-line-agentcy-text {
      font-size: 1.6rem;
      line-height: 0.2;
  }

  .login-description-box .login-partner-text {
      font-size: 1rem;
      line-height: 0.2;
  }

  .login-description-box .character {
    width: 60px;
    bottom: -4px;
  }

  .package-container {
    height: 140px;
  }

  .card-body {
    min-height: 50px;
  }

  .package-section h2 {
    font-size: 1.1em;
  }

  .card-header {
    height: 26px;
    padding-top: 1px;
  }

  .card-header h3 {
    font-size: 0.6rem;
  }

  .card-header p {
    font-size: 0.4rem;
  }

  .bordered-box {
    padding: 0;
  }

  .card-body .description {
    font-size: 0.4rem;
  }

  .card-body .price-label {
    font-size: 0.5rem;
  }

  .card-body .price {
    font-size: 0.7rem;
    gap: 1px;
  }

  .card-body .price .currency {
    font-size: 0.4rem;
  }

  .card-body .price-avg {
    font-size: 0.4rem;
  }

  .service-pricing p {
    font-size: 0.4rem;
  }

  .service-pricing strong {
    font-size: 0.6rem;
  }

  .gradient-button {
    padding: 0px 27px;
    font-size: 1.6em;
  }
}
</style>
